export default __webpack_public_path__ + "static/media/Logo.2d4bed85.png";